import { TRowData } from "../tableDataTemp";


export type HeaderGroup = {
    tableProp: string;
    group: string;
    columns: string[];
  };

export const createHeader = (row: TRowData): HeaderGroup[]=>{
    const headers:HeaderGroup[]= [];
    const keys = Object.keys(row) as Array<keyof TRowData>;

    for (const key of keys) {
        if (row[key]?.columns) {
            headers.push({tableProp:key, group: row[key]?.group || '', columns: [...Object.keys(row[key]?.columns ?? {})]});
        }
    }
    // console.log(headers);
    return headers;
}